import React from "react";
import { FormControl, FormControlProps, Paper, PaperProps } from "@mui/material";

export const StyledAdminSelectionPaper: React.FC<PaperProps> = ({ children, sx, ...rest }) => {
  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        padding: 3, // theme.spacing(3)
        marginRight: 3, // theme.spacing(3)
        marginTop: 3, // theme.spacing(3)
        minWidth: 350,
        maxWidth: 350,
        ...sx
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
};

export const StyledAdminSelectionFormControl: React.FC<FormControlProps> = ({
  children,
  sx,
  ...rest
}) => {
  return (
    <FormControl
      sx={{
        margin: "10px 0 15px 0px",
        width: "100%",
        ...sx
      }}
      {...rest}
    >
      {children}
    </FormControl>
  );
};
